import { reservationStatusBackgrounds } from '../../data/reservationStatusEnums';
import dayjs from 'dayjs';
import SidebarDailyInfo from './sidebarDailyInfo';
import SidebarWeeklyAndMonthlyInfo from './sidebarWeeklyAndMonthlyInfo';
import useStore from '@data/state/zustand';
import translate from '@data/translations';
import { Reservation } from '@pages/newReservations/resController';
import { RoomInfoEditModel } from '@common/modelDefinition';
import { orderBySimple } from '@components/orderByFunc';

interface IncommingReservationsProps {
    setReservationId: Function;
    toggleSelectRoomForReservation: Function;
    reservations: Reservation[];
    availableToTimestamp: number | null;
    availableFromTimestamp: number;
    searchTerm: string;
    rooms: RoomInfoEditModel[];
}

function IncommingReservations(props: IncommingReservationsProps) {
    const onReservationClick = (reservation: Reservation) => {
        props.setReservationId(reservation?.id);
        props.toggleSelectRoomForReservation(reservation?.roomInfoId);
    };
    const { reservations, availableToTimestamp, availableFromTimestamp } = props;

    const uiStates = useStore((appState: any) => appState.uiStates.dashboard);

    //0-earlyBird, 1-confirmed, 2-checkedIn 3-canceled, 4- closed, 5-autoblocked

    let filteredReservations = reservations ? [...reservations] : [];

    let orderBy = 'checkInTimestamp';
    if (uiStates?.showComponents.includes('sidebar_incomming')) {
        filteredReservations = reservations.filter((r) => r.statusEnum === 0 || r.statusEnum === 1);
    } else if (uiStates?.showComponents.includes('sidebar_checkedIn')) {
        filteredReservations = reservations.filter((r) => r.statusEnum === 2);
        orderBy = 'checkOutTimestamp';
    } else if (uiStates?.showComponents.includes('sidebar_canceled')) {
        filteredReservations = reservations.filter((r) => r.statusEnum === 5 || r.statusEnum === 3);
    }
    const searchTerm = props.searchTerm.toLowerCase();
    filteredReservations = filteredReservations.filter((reservations) => {
        let nameByFirstName = reservations.Customer?.firstName + ' ' + reservations.Customer?.lastName;
        let nameByLastName = reservations.Customer?.lastName + ' ' + reservations.Customer?.firstName;
        let companyName = reservations.Company?.name;

        nameByFirstName = nameByFirstName ? nameByFirstName : '';
        nameByLastName = nameByLastName ? nameByLastName : '';
        companyName = companyName ? companyName : '';

        return (
            nameByLastName.toLowerCase().includes(searchTerm) ||
            nameByFirstName.toLowerCase().includes(searchTerm) ||
            companyName.toLowerCase().includes(searchTerm) ||
            reservations.guest1CodeCopy?.toString() === searchTerm ||
            reservations.guest2CodeCopy?.toString() === searchTerm ||
            reservations.guest3CodeCopy?.toString() === searchTerm ||
            reservations.id === Number(searchTerm) ||
            reservations.RoomInfo?.name.toLowerCase().includes(searchTerm)
        );
    });

    let sortedReservationsByCheckInTimeStamp = filteredReservations.sort((a: any, b: any) => {
        return Number(a[orderBy]) - Number(b[orderBy]);
    });

    sortedReservationsByCheckInTimeStamp = orderBySimple(sortedReservationsByCheckInTimeStamp, 'statusEnum', 'desc');
    const filteredRoomsByAvailableForRent = props.rooms?.filter((room) => room.availableForRent);
    
    return !uiStates?.showComponents.includes('sidebar_dailyInfo') &&
        !uiStates?.showComponents.includes('sidebar_week/month') ? (
        <div>
            <ul className="list-group list-group-flush ">
                {sortedReservationsByCheckInTimeStamp.map((r) => {
                    const textColor = r.statusEnum === 3 ? ' text-dark ' : ' text-white ';

                    if (r.roomInfoId === null) {
                        return null;
                    }
                    if (!r.Customer && !r.Company) {
                        return 'UNKNOWN';
                    } else {
                        const checkOutDecorator =
                            r.statusEnum === 2 && r.checkOutTimestamp < Date.now() ? ' blink-animation ' : '';
                        const checkInDecorator =
                            r.statusEnum === 1 && r.checkInTimestamp < Date.now() ? ' blink-animation ' : '';
                        return (
                            <li
                                onClick={() => onReservationClick(r)}
                                key={r.id}
                                className={
                                    'list-group-item rounded pointer mt-2 mt-md-1 p-1 ' +
                                    textColor +
                                    reservationStatusBackgrounds[r.statusEnum]
                                }
                            >
                                <small>
                                    {r.Customer ? (
                                        <div className="elipsis">
                                            {r.Customer.firstName} {r.Customer.lastName} - {r.RoomInfo.name}
                                        </div>
                                    ) : null}
                                    <small>
                                        {r.Company ? (
                                            <div className="elipsis">
                                                <i className="fa fa-building mr-1" aria-hidden="true"></i>
                                                {r.Company.name} - {r.RoomInfo.name}
                                            </div>
                                        ) : null}
                                    </small>
                                </small>
                                {r.invoicedStatus === 2 ? (
                                    <div className={'elipsis '}>
                                        <small>
                                            <div className="elipsis">{translate('Paid:Partialy')}</div>
                                        </small>
                                    </div>
                                ) : r.invoicedStatus === 1 ? (
                                    <div className={'elipsis '}>
                                        <small>
                                            <div className="elipsis">
                                                {translate('Paid')}: <b>{translate('Fully')}</b>
                                            </div>
                                        </small>
                                    </div>
                                ) : null}
                                <div className={'elipsis '}>
                                    {' '}
                                    <small>
                                        <small>
                                            {' '}
                                            #{r.id} |{' '}
                                            <span className={checkInDecorator}>
                                                {dayjs(r.checkInTimestamp).format('L')}
                                            </span>{' '}
                                            -{' '}
                                            <span className={checkOutDecorator}>
                                                {dayjs(r.checkOutTimestamp).format('L')}
                                            </span>
                                        </small>
                                    </small>
                                </div>
                            </li>
                        );
                    }
                })}
                {filteredReservations.length === 0 ? (
                    <span className="pt-1 text-left">
                        <small>{translate('No reservations')}</small>
                    </span>
                ) : null}
            </ul>
        </div>
    ) : uiStates?.showComponents.includes('sidebar_dailyInfo') ? (
        <SidebarDailyInfo reservations={sortedReservationsByCheckInTimeStamp} rooms={filteredRoomsByAvailableForRent} />
    ) : uiStates?.showComponents.includes('sidebar_week/month') ? (
        <SidebarWeeklyAndMonthlyInfo
            reservations={sortedReservationsByCheckInTimeStamp}
            rooms={filteredRoomsByAvailableForRent}
            availableToTimestamp={availableToTimestamp}
            availableFromTimestamp={availableFromTimestamp}
        />
    ) : null;
}

export default IncommingReservations;
